import React, { useState, useEffect } from 'react';
function AdminPanel() {
  const [pendingSubmissions, setPendingSubmissions] = useState([]);
  const [userManagement, setUserManagement] = useState([]);
  const [playersSubmissions, setPlayersSubmissions] = useState([]);
  const [variationSubmissions, setVariationSubmissions] = useState([]);
  const [cardVariationSubmissions, setCardVariationSubmissions] = useState([]);

  useEffect(() => {
    // Simulated data
    const pendingSubmissionsData = [
        { submissionId: 29, tableName: 'players', idInserted: 2289, userId: 1, approved: 0 },
        { submissionId: 28, tableName: 'players', idInserted: 2288, userId: 1, approved: 0 },
        { submissionId: 27, tableName: 'players', idInserted: 2287, userId: 1, approved: 0 },
        { submissionId: 26, tableName: 'players', idInserted: 2286, userId: 1, approved: 0 },
        { submissionId: 25, tableName: 'players', idInserted: 2285, userId: 1, approved: 0 },
        { submissionId: 24, tableName: 'players', idInserted: 2284, userId: 1, approved: 0 },
        { submissionId: 23, tableName: 'players', idInserted: 2283, userId: 1, approved: 0 },
        { submissionId: 22, tableName: 'players', idInserted: 2282, userId: 1, approved: 0 },
        { submissionId: 21, tableName: 'players', idInserted: 2281, userId: 1, approved: 0 },
        { submissionId: 20, tableName: 'players', idInserted: 2280, userId: 1, approved: 0 },
        { submissionId: 19, tableName: 'players', idInserted: 2279, userId: 1, approved: 0 },
        { submissionId: 18, tableName: 'players', idInserted: 2278, userId: 1, approved: 0 },
        { submissionId: 17, tableName: 'variation', idInserted: 18, userId: 1, approved: 0 },
        { submissionId: 16, tableName: 'variation', idInserted: 17, userId: 1, approved: 0 },
        { submissionId: 15, tableName: 'cardvariation', idInserted: 9, userId: 1, approved: 0 },
        { submissionId: 14, tableName: 'variation', idInserted: 16, userId: 1, approved: 0 },
        { submissionId: 13, tableName: 'cardvariation', idInserted: 8, userId: 1, approved: 0 },
        { submissionId: 12, tableName: 'variation', idInserted: 15, userId: 1, approved: 0 },
        { submissionId: 11, tableName: 'variation', idInserted: 14, userId: 1, approved: 0 },
        { submissionId: 10, tableName: 'variation', idInserted: 13, userId: 1, approved: 0 },
        { submissionId: 9, tableName: 'players', idInserted: 2277, userId: 1, approved: 0 },
        { submissionId: 8, tableName: 'variation', idInserted: 12, userId: 1, approved: 0 },
        { submissionId: 7, tableName: 'players', idInserted: 2276, userId: 1, approved: 0 },
        { submissionId: 6, tableName: 'variation', idInserted: 11, userId: 1, approved: 0 },
        { submissionId: 5, tableName: 'players', idInserted: 2275, userId: 1, approved: 0 },
      ];  
      
    
  



      
      
        const players = pendingSubmissionsData.filter((submission) => submission.tableName === 'players');
        const variation = pendingSubmissionsData.filter((submission) => submission.tableName === 'variation');
        const cardVariation = pendingSubmissionsData.filter((submission) => submission.tableName === 'cardvariation');
        // Update state with organized submissions
        setPlayersSubmissions(players);
        setVariationSubmissions(variation);
        setCardVariationSubmissions(cardVariation);


     


    const userManagementData = [
      // Simulated user data
      { userId: 1, username: 'admin', role: 'admin' },
      { userId: 2, username: 'moderator', role: 'moderator' },
      // Add more data as needed
    ];

    setPendingSubmissions(pendingSubmissionsData);
    setUserManagement(userManagementData);
  }, []); // Empty dependency array to run only once on mount





  const approveSubmission = (submissionId) => {
    // Implement logic to approve submission (simulated)
    console.log(`Submission ${submissionId} approved`);
  };

  const disapproveSubmission = (submissionId) => {
    // Implement logic to disapprove submission (simulated)
    console.log(`Submission ${submissionId} disapproved`);
  };

  const editUser = (userId) => {
    // Implement logic to edit user (simulated)
    console.log(`Editing user ${userId}`);
  };

  const deleteUser = (userId) => {
    // Implement logic to delete user (simulated)
    console.log(`Deleting user ${userId}`);
  };

  return (
    <div className="admin-panel">
      <h1>Admin Panel</h1>



      <div className="pending-submissions">
        <h2>Pending Submissions</h2>
        {pendingSubmissions.map((submission) => (
          <div key={submission.submissionId} className="submission-item">
            <p>{`${submission.tableName} - ID ${submission.idInserted} - User ${submission.userId}`}</p>
            <button onClick={() => approveSubmission(submission.submissionId)}>Approve</button>
            <button onClick={() => disapproveSubmission(submission.submissionId)}>Disapprove</button>
          </div>
        ))}
      </div>
      <div className="user-management">
        <h2>User Management</h2>
        {userManagement.map((user) => (
          <div key={user.userId} className="user-item">
            <p>{`${user.username} - Role: ${user.role}`}</p>
            <button onClick={() => editUser(user.userId)}>Edit</button>
            <button onClick={() => deleteUser(user.userId)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminPanel;
